module.exports = __webpack_public_path__ + "officialStatic/img/tsw.aa21e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/tsw.png
// module id = WEWu
// module chunks = 0